import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Gift, CheckCircle, ArrowRight } from './Icons';
import { CTAButton } from './CTAButton';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function ValueStack() {
  return <section className="py-10 md:py-20 px-4 bg-cream relative" data-id="element-161">
      <div className="max-w-5xl mx-auto" data-id="element-162">
        <div className="text-center mb-8 md:mb-16" data-id="element-163">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-navy mb-4" data-id="element-164">
            Todo lo que recibes hoy
          </h2>
          <div className="w-24 h-1 bg-terracotta mx-auto rounded-full" data-id="element-165"></div>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="space-y-4 md:space-y-6" data-id="element-166">
          {/* MAIN PRODUCT */}
          <motion.div variants={itemVariants} className="bg-white rounded-3xl p-6 md:p-8 shadow-xl border-2 border-terracotta/20 flex flex-col md:flex-row gap-8 items-center relative overflow-hidden" data-id="element-167">
            <div className="absolute top-0 left-0 bg-terracotta text-white px-4 py-1 rounded-br-xl font-bold text-sm z-10" data-id="element-168">
              PRODUCTO PRINCIPAL
            </div>
            <div className="w-full md:w-1/3 relative pt-6 md:pt-0" data-id="element-169">
              <img src="https://cdn.magicpatterns.com/uploads/w6tcuMDdoFG3K8Zzdh2vn6/mk1.png" alt="Ebook Infancia Analógica" className="w-full h-auto rounded-xl shadow-md transform -rotate-2" data-id="element-170" />
            </div>
            <div className="w-full md:w-2/3" data-id="element-171">
              <div className="flex items-center gap-3 mb-2" data-id="element-172">
                <BookOpen className="w-6 h-6 text-terracotta" data-id="element-173" />
                <h3 className="text-2xl font-bold text-navy" data-id="element-174">
                  Ebook: Infancia Analógica 2026
                </h3>
              </div>
              <p className="text-lg text-warm-medium mb-4" data-id="element-175">
                El sistema paso a paso de 30 días para re-setear la atención de
                tu hijo.
              </p>
              <div className="inline-block bg-cream-dark px-4 py-2 rounded-lg font-bold text-warm-dark" data-id="element-176">
                Valor normal:{' '}
                <span className="strike-through text-warm-medium font-normal" data-id="element-177">
                  $97.00
                </span>
              </div>
            </div>
          </motion.div>

          {/* BONUS 1 */}
          <motion.div variants={itemVariants} className="bg-white rounded-3xl p-6 md:p-8 shadow-lg border border-cream-dark flex flex-col md:flex-row gap-8 items-center" data-id="element-178">
            <div className="w-full md:w-1/3" data-id="element-179">
              <img src="https://cdn.magicpatterns.com/uploads/aQUrqvLcLsrN8DQmXGkZze/bn1.png" alt="Kit Cena Fuera Sin iPad" className="w-full h-auto rounded-xl shadow-md" data-id="element-180" />
            </div>
            <div className="w-full md:w-2/3" data-id="element-181">
              <div className="flex items-center gap-2 mb-2" data-id="element-182">
                <span className="bg-amber text-white text-xs font-bold px-2 py-1 rounded uppercase tracking-wider" data-id="element-183">
                  Bono 1
                </span>
              </div>
              <h3 className="text-xl md:text-2xl font-bold text-navy mb-2" data-id="element-184">
                Kit "Cena Fuera Sin iPad"
              </h3>
              <p className="text-lg text-warm-medium mb-4" data-id="element-185">
                ¡Adiós a la tablet en los restaurantes! Estrategias infalibles
                para comer en paz.
              </p>
              <div className="inline-block bg-cream-dark px-4 py-2 rounded-lg font-bold text-warm-dark" data-id="element-186">
                Valor normal:{' '}
                <span className="strike-through text-warm-medium font-normal" data-id="element-187">
                  $67.00
                </span>
              </div>
            </div>
          </motion.div>

          {/* BONUS 2 */}
          <motion.div variants={itemVariants} className="bg-white rounded-3xl p-6 md:p-8 shadow-lg border border-cream-dark flex flex-col md:flex-row gap-8 items-center" data-id="element-188">
            <div className="w-full md:w-1/3" data-id="element-189">
              <img src="https://cdn.magicpatterns.com/uploads/5UAhv93QmwTQAjfLk2bS8u/bn2.png" alt="50 Invitaciones al Juego Solo" className="w-full h-auto rounded-xl shadow-md" data-id="element-190" />
            </div>
            <div className="w-full md:w-2/3" data-id="element-191">
              <div className="flex items-center gap-2 mb-2" data-id="element-192">
                <span className="bg-amber text-white text-xs font-bold px-2 py-1 rounded uppercase tracking-wider" data-id="element-193">
                  Bono 2
                </span>
              </div>
              <h3 className="text-xl md:text-2xl font-bold text-navy mb-2" data-id="element-194">
                50 Invitaciones al "Juego Solo"
              </h3>
              <p className="text-lg text-warm-medium mb-4" data-id="element-195">
                Actividades "Zero-Prep" para que tú puedas descansar 30 minutos
                mientras ellos juegan felices.
              </p>
              <div className="inline-block bg-cream-dark px-4 py-2 rounded-lg font-bold text-warm-dark" data-id="element-196">
                Valor normal:{' '}
                <span className="strike-through text-warm-medium font-normal" data-id="element-197">
                  $47.00
                </span>
              </div>
            </div>
          </motion.div>

          {/* BONUS 3 */}
          <motion.div variants={itemVariants} className="bg-white rounded-3xl p-6 md:p-8 shadow-lg border border-cream-dark flex flex-col md:flex-row gap-8 items-center" data-id="element-198">
            <div className="w-full md:w-1/3" data-id="element-199">
              <img src="https://cdn.magicpatterns.com/uploads/5L7J9Kc2628hevTpKkpSp4/bn3.png" alt="Guía Mi Primer Celular" className="w-full h-auto rounded-xl shadow-md" data-id="element-200" />
            </div>
            <div className="w-full md:w-2/3" data-id="element-201">
              <div className="flex items-center gap-2 mb-2" data-id="element-202">
                <span className="bg-amber text-white text-xs font-bold px-2 py-1 rounded uppercase tracking-wider" data-id="element-203">
                  Bono 3
                </span>
              </div>
              <h3 className="text-xl md:text-2xl font-bold text-navy mb-2" data-id="element-204">
                Guía "Mi Primer Celular"
              </h3>
              <p className="text-lg text-warm-medium mb-4" data-id="element-205">
                Cómo negociar, retrasar el smartphone y establecer un contrato
                familiar saludable.
              </p>
              <div className="inline-block bg-cream-dark px-4 py-2 rounded-lg font-bold text-warm-dark" data-id="element-206">
                Valor normal:{' '}
                <span className="strike-through text-warm-medium font-normal" data-id="element-207">
                  $97.00
                </span>
              </div>
            </div>
          </motion.div>
        </motion.div>

        {/* PRICE SUMMARY */}
        <motion.div id="oferta" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="mt-8 md:mt-16 bg-navy text-white rounded-2xl md:rounded-3xl p-6 md:p-12 text-center shadow-2xl relative overflow-hidden scroll-mt-8" data-id="element-208">
          <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-terracotta via-amber to-terracotta" data-id="element-209"></div>

          <p className="text-xl text-sage-light mb-2 font-medium" data-id="element-210">
            Resumen de tu inversión:
          </p>
          <div className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-8 mb-8" data-id="element-211">
            <div className="text-center" data-id="element-212">
              <p className="text-sm uppercase tracking-widest text-warm-medium mb-1" data-id="element-213">
                Valor Total
              </p>
              <p className="text-3xl font-bold strike-through text-warm-medium" data-id="element-214">
                $552.00
              </p>
            </div>
            <ArrowRight className="w-8 h-8 text-terracotta hidden md:block" data-id="element-215" />
            <div className="text-center bg-white/10 px-8 py-4 rounded-2xl backdrop-blur-sm border border-white/20" data-id="element-216">
              <p className="text-sm uppercase tracking-widest text-amber mb-1 font-bold" data-id="element-217">
                Precio de Validación Hoy
              </p>
              <p className="text-5xl md:text-6xl font-bold text-white" data-id="element-218">
                $13.99
              </p>
            </div>
          </div>

          <div className="max-w-2xl mx-auto" data-id="element-219">
            <CTAButton data-id="element-220" />
          </div>
        </motion.div>
      </div>
    </section>;
}